export function getContainerStyle() {
    return {
        root: {
            borderRadius: "4px",
            height: "100%",
            marginTop: "0px",
            /* increased by 20px
            = 12px (space for the scrollbar to be rendered, opposite of -12px in ScrollableStack.styles.tsx)
            + 8px (width of gap between FeedContainer and scrollbar from design) */
            minWidth: "658px",
        },
    };
}
export function getFeedContainerAndWidgetFrameBumperStyle() {
    return {
        borderRadius: "8px",
        display: "flex",
        height: "100%",
        justifyContent: "center",
        width: "100%",
    }; // as React.CSSProperties is a necessary workaround for https://github.com/Microsoft/TypeScript/issues/16457
}
export function getFeedErrorComponentStyle(theme) {
    return {
        root: {
            border: theme === null || theme === void 0 ? void 0 : theme.customSemanticElevations.layer.border,
            borderRadius: "8px",
            boxShadow: theme === null || theme === void 0 ? void 0 : theme.customSemanticElevations.card.boxShadow,
            height: "304px",
            marginTop: "120px"
        },
    };
}
export function getFeedErrorStateStyle() {
    return {
        root: {
            height: 0,
            overflow: "hidden",
            visibility: "hidden",
        },
    };
}
